module.exports = __webpack_public_path__ + "img/LOGO_SOLO.bce4a814.png";